import { useState } from "react";
import { Controller } from "react-hook-form";
import { Box, FormHelperText, FormLabel } from "@material-ui/core";

import { IUser } from "../../../../types/user/iuser.interface";

import { UsersSearch } from "../../../users/components/users-search/users-search.component";

import { useFieldsStyles } from "../fields.styles";

import { UserSearchFieldProps } from "./user-search-field.props";
import { UserSearchFieldSelection } from "./components/user-search-field-selection/user-search-field-selection.component";

export const UserSearchField = (props: UserSearchFieldProps) => {
  const [shouldResetSearch, setShouldResetSearch] = useState(true);

  const SelectionComponent = props.SelectionComponent ?? UserSearchFieldSelection;

  const commonClasses = useFieldsStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;
  const canEdit = Boolean(props.userPermissions?.canEdit) || Boolean(props.noAuthRequired);
  const multiple = props.multiple ?? true;

  const handleSelect = (user: IUser, value: IUser[], onChange: (data: IUser[]) => void) => {
    let data: IUser[];

    if (multiple) {
      data = value.concat([user]);
    } else {
      data = [user];
    }

    onChange(data);
    setShouldResetSearch(!shouldResetSearch);
  };

  const handleRemove = (id: number, value: IUser[], onChange: (data: IUser[]) => void) => {
    const data = value.filter((user) => id !== user.id);
    onChange(data);
  };

  const isUserReadonly = (user: IUser) =>
    Boolean(!canEdit || (props.userReadonly && props.userReadonly(user)));

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <label className={commonClasses.fieldWrapper}>
          <Box display="flex" justifyContent="space-between">
            <FormLabel htmlFor={props.name} error={hasError} required={props.required}>
              {props.label}
            </FormLabel>
          </Box>

          <UsersSearch
            currentValue={renderProps.field.value}
            groupFilter={props.groupFilter}
            id={props.name}
            isDisabled={!canEdit}
            onSelect={(user) =>
              handleSelect(user, renderProps.field.value, renderProps.field.onChange)
            }
            reset={shouldResetSearch}
            resourceId={props.resourceId}
            resourceType={props.resourceType}
          />

          <SelectionComponent
            form={props.form}
            isUserReadonly={isUserReadonly}
            onRemove={(id: number) =>
              handleRemove(id, renderProps.field.value, renderProps.field.onChange)
            }
            resourceId={props.resourceId}
            showIf={renderProps.field.value}
            userMarkers={props.userMarkers}
            users={renderProps.field.value}
            userPermissions={props.userPermissions}
          />

          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </label>
      )}
    />
  );
};
